// =============================================================================
// The setup sequence, as pure functions.
//
// Lives here rather than in the web app because it had a bug that only showed
// once every step was finished — the state hardest to reach by clicking and
// easiest to assert in a test.
//
// The sequence is the order the work can actually be done in: nothing to write
// for until a brand exists, nowhere to publish until a page is connected, no
// voice to write in until someone sets one.
// =============================================================================
export const ONBOARDING_SEQUENCE = ["brand", "connect", "voice", "post"];
/**
 * Turns "which steps are done" into the full sequence state.
 *
 * Locking is computed by a single scan rather than per-step rules, so the
 * order is defined in exactly one place: ONBOARDING_SEQUENCE.
 */
export function resolveSteps(done) {
    let blocked = false;
    return ONBOARDING_SEQUENCE.map((key) => {
        const isDone = done[key];
        const locked = blocked;
        if (!isDone)
            blocked = true;
        return { key, done: isDone, locked };
    });
}
/** The first unfinished step, or null once setup is complete. */
export function nextStep(steps) {
    return steps.find((s) => !s.done) ?? null;
}
/**
 * Whether a navigation row is the one to do next.
 *
 * The guard on `itemStep` is the whole point. Written as
 * `next?.key === itemStep`, this compared undefined to undefined the moment
 * setup finished: `next` becomes null, and every row that has no step at all
 * — Campaigns, Calendar, Schedule — matched and lit up as NEXT. The guidance
 * exists for someone finding their way; once they have, it must disappear.
 */
export function isNextStep(itemStep, next) {
    if (itemStep === undefined || next === null)
        return false;
    return next.key === itemStep;
}
/** How far through setup, for the progress bar. */
export function setupProgress(steps) {
    const done = steps.filter((s) => s.done).length;
    return { done, total: steps.length, complete: done === steps.length };
}
//# sourceMappingURL=onboarding.js.map